import React from 'react';
import { useTheme } from '@corti/theme';
import { Base } from 'lib/cortiUI';
export function ListCell(props) {
    const { children, alignment = 'left' } = props;
    const theme = useTheme();
    return (React.createElement(Base, { mx: theme.space[6], height: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: alignment === 'left' ? 'flex-start' : 'flex-end', overflowX: "hidden" }, children));
}
